import React, { useState, useEffect, useCallback, useRef } from 'react';
import { Button, Col, Label, Input, InputGroup, InputGroupText, Modal, ModalFooter, ModalBody, ModalHeader, Row } from 'reactstrap';
import Name from '../common/Name';
import Address from '../common/Address';
import Phone from '../common/Phone';
import PersonTypes from '../common/LookupDropDown';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import { getOptions } from '../../utils';
const getInitialState = (props) => {
    return {
        fromEdit: true,
        isPrimary: (props.editContactDetails && props.editContactDetails[0].isPrimary),
        personTypeId: (props.editContactDetails && props.editContactDetails[0]?.personTypeId),
        generation: props.editContactDetails && props.editContactDetails[0].generation,
        properTitle: props.editContactDetails && props.editContactDetails[0].properTitle,
        firstName: props.editContactDetails && props.editContactDetails[0].firstName,
        middleName: props.editContactDetails && props.editContactDetails[0].middleName,
        lastName: props.editContactDetails && props.editContactDetails[0].lastName,
        disableAddContactButton: true,
        emails: (props.editContactDetails && props.editContactDetails[0]?.emails),
        addresses: (props.editContactDetails && props.editContactDetails[0]?.addresses),
        phones: [
            (props.editContactDetails && props.editContactDetails?.[0].phones[0]) || [],
            (props.editContactDetails && props.editContactDetails?.[0].phones[1]) || [],
        ],
        isActive: (props.editContactDetails && props.editContactDetails[0]?.isActive) ?? true,
        personId: (props.editContactDetails && props.editContactDetails[0]?.personId)
    };
};

const EditModal = (props) => {
    const [state, setState] = useState(getInitialState(props));
    const { onAdd, contactNameIsValid, toggleValidState, toggle, personTypes, phoneTypes, properTitles, generations, isOpen, modalTitle, editContactDetails, states } = props;
    const [phoneEqual, setPhoneEqual] = useState();
    const initialState = useRef(getInitialState(props));

    useEffect(() => {
        setState(getInitialState(props));
    }, [props]);

    const handleAdd = useCallback(() => {
        const phones = state.phones.filter(personPhone =>
            personPhone && personPhone.phone && (personPhone.phone.formattedNumber || personPhone.phone.phoneId)
        );

        setState(prevState => ({ ...prevState, phones }));
        onAdd({ ...state, phones }); 

        setState(getInitialState(props));

        toggle();
    }, [state, onAdd, props, toggle]);

    const handleNameOnChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({ ...prevState, [name]: value }));
    };

    const handleOnChange = (e) => {
        const { name, value } = e.target;
        setState(prevState => ({ ...prevState, [name]: value }));
    };

    const handleAddressOnChange = (name, value) => {
        setState(prevState => {
            const updatedAddresses = prevState.addresses.map((address, index) => {
                if (index === 0) {
                    return {
                        ...address,
                        address: {
                            ...address.address,   
                            [name]: value,      
                        },
                    };
                }
                return address;
            });

            return { ...prevState, addresses: updatedAddresses };
        });
    };

    const isFormChanged = () => {
        return JSON.stringify(state) !== JSON.stringify(initialState.current);
    };

    const handlePrimaryPhoneOnChange = (phone) => {
        setState(prevState => {
            const updatedPhones = [...prevState.phones];
            updatedPhones[0] = phone?.formattedNumber
                ? { ...updatedPhones[0], phone }
                : { ...updatedPhones[0], phone: { phoneId: updatedPhones[0]?.phone?.phoneId, formattedNumber: '' } };
            return { ...prevState, phones: updatedPhones };
        });
    };

    const handleSecondaryPhoneOnChange = (phone) => {
        setState(prevState => {
            const updatedPhones = [...prevState.phones];
            updatedPhones[1] = phone?.formattedNumber
                ? { ...updatedPhones[1], phone }
                : { ...updatedPhones[1], phone: { phoneId: updatedPhones[1]?.phone?.phoneId, formattedNumber: '' } };
            return { ...prevState, phones: updatedPhones };
        });
    };

    const setPhoneTypePrimary = (e) => {
        const { value } = e.target;
        const selectedPhoneType = phoneTypes.find(type => type.lookupId.toString() === value);

        setState(prevState => {
            const updatedPhones = [...prevState.phones];
            updatedPhones[0] = {
                ...updatedPhones[0],
                phoneTypeId: selectedPhoneType ? selectedPhoneType.lookupId : null,
                phone: {
                    ...updatedPhones[0]?.phone,
                },
            };

            return { phones: updatedPhones };
        });
    };

    const setPhoneTypeSecondary = (e) => {
        const { value } = e.target;
        const selectedPhoneType = phoneTypes.find(e => e.lookupId.toString() === value);

        setState(prevState => {
            const updatedPhones = [...prevState.phones];
            updatedPhones[1] = {
                ...updatedPhones[1],
                phoneTypeId: selectedPhoneType ? selectedPhoneType.lookupId : null,
                phone: {
                    ...updatedPhones[1].phone,
                },
            };

            return { phones: updatedPhones };
        });
    };

    const firstNameIsValid = () => {
        return state.firstName && state.firstName !== '';
    };

    const lastNameIsValid = () => {
        return state.lastName && state.lastName !== '';
    };

    const getTypes = () => {
        return [
            <option key={0} value={''} disabled>Select a Type</option>,
            ...phoneTypes.map((item, index) => (
                <option key={index + 1} value={item.lookupId}>{item.name}</option>
            ))
        ];
    };

    const handleEmailOnChange = (e) => {
        setState(prevState => {
            const updatedEmails = [...prevState.emails];
            if (updatedEmails.length === 0) {
                updatedEmails.push({ isActive: true, isPrimary: true, emailAddress: e.target.value });
            } else {
                updatedEmails[0].emailAddress = e.target.value;
            }
            return { ...prevState, emails: updatedEmails };
        });
    };

    const closeModal = () => {
        toggleValidState(false);
        setState(getInitialState(props));
        toggle();
    };

    const reguarExp = new RegExp('[^@ \t\r\n]+@[^@ \t\r\n]+.[^@ \t\r\n]+');

    const markEmailAsInvalid = state.emails[0]?.emailAddress && !reguarExp.test(state.emails[0]?.emailAddress);
    const personTypesToSend = personTypes.filter(person => person.name !== "Staff");

    return (
        <Modal isOpen={isOpen} toggle={closeModal} size='lg'>
            <ModalHeader toggle={closeModal}>{modalTitle}</ModalHeader>
            <ModalBody>
                <Row>
                    <Col>
                        <Label>*First Name:</Label>
                        <InputGroup>
                            <InputGroupText>
                                <Input addon name='properTitle' type="select" className='bg-transparent border-0 p-0 h-100' onChange={(e) => handleNameOnChange(e)} value={state.properTitle || ''}>
                                    <option key={null} value={null}></option>
                                    {getOptions(properTitles, false, true)}
                                </Input>
                            </InputGroupText>
                            <Input
                                name='firstName'
                                invalid={!firstNameIsValid()}
                                type='text'
                                onChange={(e) => handleNameOnChange(e)}
                                value={state.firstName || ''} />
                        </InputGroup>
                    </Col>
                    <Col>
                        <Label>Middle Name:</Label>
                        <Input
                            name='middleName'
                            type='text'
                            onChange={(e) => handleNameOnChange(e)}
                            value={state.middleName || ''} />
                    </Col>
                    <Col>
                        <Label>*Last Name:</Label>
                        <InputGroup>
                            <Input
                                name='lastName' type='text'
                                invalid={!lastNameIsValid()}
                                onChange={(e) => handleNameOnChange(e)}
                                value={state.lastName || ''} />
                            <InputGroupText>
                                <Input addon name='generation' type='select' id='selectGeneration' className='bg-transparent border-0 p-0 h-100' onChange={(e) => handleNameOnChange(e)} value={state.generation || ''}>
                                    <option key={null} value={null}></option>
                                    {getOptions(generations, false, true)}
                                </Input>
                            </InputGroupText>
                        </InputGroup>
                    </Col>
                </Row>
                <Row className='mb-1'>
                    <Col>
                        <PersonTypes
                            label='Person Type'
                            name='personTypeId'
                            value={state.personTypeId}
                            onChange={handleOnChange}
                            lookups={personTypesToSend}
                        />
                    </Col>
                    <Col>
                        <Label>Email:</Label>
                        <Input name='email' invalid={markEmailAsInvalid} type='input' onChange={handleEmailOnChange} value={state.emails[0]?.emailAddress || ''}></Input>
                    </Col>
                </Row>
                <Row className='mb-1'>
                    <Col>
                        <Label>Phone Type:</Label>
                        <Input name='phoneType' type='select' id='selectPhoneType' onChange={(e) => setPhoneTypePrimary(e)} value={state.phones[0]?.phoneTypeId || ''}>
                            {getTypes()}
                        </Input>
                    </Col>
                    <Col>
                        <Label>*Number:</Label>
                        <Phone
                            id={'primaryPhone'}
                            toggleContactPhoneIsValid={props.toggleContactPhoneIsValid}
                            phone={state.phones[0] ? state.phones[0].phone : {}}
                            onChange={handlePrimaryPhoneOnChange}
                        />
                    </Col>
                </Row>
                <Row className='mb-1'>
                    <Col>
                        <Label>Phone Type:</Label>
                        <Input name='phoneType' type='select' id='selectPhoneType' onChange={(e) => setPhoneTypeSecondary(e)} value={state.phones[1]?.phoneTypeId || ''}>
                            {getTypes()}
                        </Input>
                    </Col>
                    <Col>
                        <Label>Secondary Phone:</Label>
                        <Phone
                            id={'secondaryPhone'}
                            toggleContactPhoneIsValid={props.toggleContactPhoneIsValid}
                            phone={state.phones[1] ? state.phones[1].phone : {}}
                            onChange={handleSecondaryPhoneOnChange}
                        />
                    </Col>
                </Row>
                <Row className='mb-1'>
                    <Col>
                        <Address
                            {...state.addresses[0]?.address}
                            onChange={handleAddressOnChange}
                            states={states}
                        />
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button color="primary" disabled={!firstNameIsValid() || !lastNameIsValid() || markEmailAsInvalid || !isFormChanged()} onClick={handleAdd}>Update</Button>
                <Button color="secondary" onClick={closeModal}>Cancel</Button>
            </ModalFooter>
        </Modal>
    );
};

const mapStateToProps = (state) => ({
    editContactDetails: state.PersonData.get('editContactDetails'),
    phoneTypes: state.StaticData.get('phoneTypes').toJS(),
});

export default connect(mapStateToProps)(EditModal);